import { useAct } from 'DashboardUser/store'

export default function MultipleChoiceFilter({filterKey, closeConfiguration}) {
    const act = useAct();

    const dashboardField = useSel(s => s.dashboard.dashboardFields.find(f => 'field_' + f.id === filterKey) ?? null);
    const questions = useSel(s => s.dashboard.survey.questions);
    const filter = useSel(s => s.local.filters ? s.local.filters[filterKey] : null);

    const [value, setValue] = useState(filter);
    const question = questions ? questions.find(q => q.id === dashboardField?.questionId) : null;
    const answers = question?.answers || [];

    const setFilter = (val) => {
        act.local.setFilter(filterKey, val);
        setValue(val);
        closeConfiguration();
    }

    const clearFilter = () => {
        act.local.setFilter(filterKey, null);
        setValue(null);
        closeConfiguration();
    }

    return <div className="multiple-choice-filter">
        {answers.map(answer => (
            <a
                href="#"
                key={answer.id}
                className={`filter-configuration-option ${String(value) === String(answer.id) ? 'selected' : ''}`}
                onClick={() => setFilter(String(answer.id))}
            >
                {answer.answer}
            </a>
        ))}
        <div className='filter-configuration-option-divider'></div>
        <a href="#" className={`filter-configuration-option ${filter === '[present]' ? 'active' : ''}`} onClick={() => setFilter('[present]')}>Answered</a>
        <a href="#" className={`filter-configuration-option ${filter === '[blank]' ? 'active' : ''}`} onClick={() => setFilter('[blank]')}>Not Answered</a>
        {filter && <>
            <div className="filter-configuration-option-divider"></div>
            <a href="#" className="filter-configuration-option configuration-option-clear" onClick={clearFilter}>Clear</a>
        </>}
    </div>
}